export default (value = '') => value.charAt(0).toUpperCase() + value.slice(1);



// WEBPACK FOOTER //
// ./sources/filters/capitalize.js